import { ContainerStackScreen } from "@Components/ContainerStackScreen"
import { Button } from "@Components/CustomButton/Button"
import SvgMascotte from "@Components/CustomIcon/SvgMascotte"
import { CustomScrollview } from "@Components/CustomScrollView/CustomScrollView"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { ReportCardItem } from "@Components/FollowUp/Report/ReportCardItem"
import { CustomDropDownPicker } from "@Components/FollowUp/Toolbox/CustomDropdownPicker"
import { CustomPicker } from "@Components/FollowUp/Toolbox/CustomPicker"
import { DaySelector } from "@Components/FollowUp/Toolbox/DaySelector"
import { MultipleDaySelector } from "@Components/FollowUp/Toolbox/MultipleDaySelector"
import { InputGroup } from "@Components/Input/InputGroups"
import CustomSimpleModal from "@Components/Modal/CustomSimpleModal/CustomSimpleModal"
import { Spacer } from "@Components/Space"
import { ShowToast } from "@Components/ToastNotification/ToastNotification"
import { baseColors } from "@Constants/baseStyles"
import { message } from "@Constants/constant"
import { FontAwesome5, Ionicons, MaterialIcons } from "@expo/vector-icons"
import { activityTypesAtom } from "@Recoil/Atom/activityAtom"
import { ActivityService } from "@Services/Activity.Service"
import { dbDateFormat, getSportIcon, isNumber, isValidTime } from "@Utils/utils"
import moment from "moment"
import React, { useEffect, useState } from "react"
import { Platform, ScrollView, TouchableOpacity, View } from "react-native"
import { RFValue } from "react-native-responsive-fontsize"
import { useRecoilValue } from "recoil"
import DateTimePicker from "@react-native-community/datetimepicker"

const defaultActivity = {
    activityTypeId: null,
    sportId: null,
    duration: "",
    start: moment(new Date()).format("HH:mm"),
    recurrenceDays: []
}
export const ActivityForm = ({ navigation }) => {
    const [fetchingActivity, setFetchingActivity] = useState(false)
    const [fetchingSports, setFetchingSport] = useState(false)
    const [activity, setActivity] = useState(defaultActivity)
    const activities = useRecoilValue(activityTypesAtom)
    const [sports, setSports] = useState([])
    const [loading, setLoading] = useState(false)
    const [savingSport, setSavingSport] = useState(false)
    const [openSportModal, setOpenSportModal] = useState(false)
    const [sportName, setSportName] = useState("")
    const [datePickerVisible, setDatePickerVisible] = useState(false)
    const [time, setTime] = useState(moment(new Date()).format("HH:mm"))

    const performSaveSport = () => {
        const exist = sports?.filter((sprt) => sprt?.label?.toLowerCase() === sportName.toLowerCase())
        if (sportName?.length > 0) {
            if (exist.length === 0) {
                setSavingSport(true)
                ActivityService.createSport(sportName)
                    .then((response) => {
                        ShowToast({ type: "success", message: `${sportName} ajouté à la liste des sports` })
                        const data = response.data?.data

                        setSportName("")

                        fetchSport(() => {
                            setActivity((old) => ({ ...old, sportId: data?.id }))
                            setOpenSportModal(false)
                        })
                        setSavingSport(false)
                    })
                    .catch((e) => {
                        ShowToast({ type: "error", message: "Une erreur est survenue lors de la création de sport" })
                        setSavingSport(false)
                    })
            } else {
                alert("ce sport existe déjà !")
            }
        }
    }

    const fetchSport = (callBack) => {
        setFetchingSport(true)
        ActivityService.getSports()
            .then((response) => {
                const data = response.data?.data
                if (data) {
                    let parsedData = data.map((item) => {
                        let newObj = {
                            id: item.id,
                            label: item.name
                        }
                        return newObj
                    })
                    parsedData.push({
                        id: -1,
                        label: "autres"
                    })
                    setSports(parsedData)
                    callBack?.()
                }
                setFetchingSport(false)
            })
            .catch((e) => {
                setFetchingSport(false)
                ShowToast({ type: "error", message: message.serverError })
            })
    }

    useEffect(() => {
        fetchSport()
    }, [])

    const canSubmit = () =>
        activity.recurrenceDays.length > 0 &&
        activity.activityTypeId &&
        activity.sportId > 0 &&
        isNumber(activity.duration) &&
        isValidTime(activity.start)

    const performSaveActivity = () => {
        setLoading(true)
        ActivityService.create({ ...activity })
            .then((response) => {
                setLoading(false)
                ShowToast({ type: "success", message: message.createdActivity })
                setActivity(defaultActivity)
                navigation.goBack()
            })
            .catch(() => {
                setLoading(false)
                ShowToast({ type: "error", message: message.serverError })
            })
    }

    const renderItem = ({ item }, { onPress }) => {
        return (
            <TouchableOpacity
                onPress={() => {
                    setActivity((old) => ({ ...old, sportId: item.id }))
                }}
                activeOpacity={0.7}
                style={{ flexDirection: "row", padding: 10 }}
            >
                <View style={{ marginRight: 20 }}>{item.icon}</View>
                <OpenSansText fontSize={16}>{item.name}</OpenSansText>
            </TouchableOpacity>
        )
    }

    const onChangeDateTime = (event, selectedDate) => {
        setDatePickerVisible(false)
        const currentDate = selectedDate
        if (currentDate) {
            setActivity((old) => ({ ...old, start: moment(currentDate).format("HH:mm") }))
        }
    }

    const onChangeWebDateTime = (dateTimeValue) => {
        if (dateTimeValue) {
            setActivity((old) => ({ ...old, start: dateTimeValue }))
        }
    }

    return (
        <ContainerStackScreen>
            <CustomScrollview contentContainerStyle={{ paddingBottom: 100 }} showsVerticalScrollIndicator={false}>
                <CustomSimpleModal open={openSportModal} toggleModal={() => (loading ? {} : setOpenSportModal(false))}>
                    <BreeSerifText style={{ padding: 15 }} textAlign={"center"} fontSize={20}>
                        Ajoutez un sport
                    </BreeSerifText>
                    <Spacer height={5} />
                    <InputGroup
                        onChange={(txt) => setSportName(txt)}
                        placeholder="Exemple : Badminton"
                        label=" Nom du sport (icône par défaut)"
                    />
                    <Button
                        loading={savingSport}
                        disabled={sportName?.length === 0 || savingSport}
                        onPress={() => {
                            performSaveSport()
                        }}
                        text="valider"
                        width="60%"
                        backgroundColor={baseColors.green.primary}
                        labelColor={"white"}
                    />
                </CustomSimpleModal>
                <BreeSerifText color={baseColors.black} fontSize={24}>
                    Ajouter une activité
                </BreeSerifText>
                <Spacer height={15} />
                <OpenSansText fontSize={16}>Choisissez un type d’activité physique</OpenSansText>
                <Spacer height={15} />
                <CustomPicker
                    value={activity.activityTypeId}
                    handleChange={(value) => setActivity((old) => ({ ...old, activityTypeId: value }))}
                    disabled={fetchingActivity || loading}
                    data={activities}
                    title={"Sélectionnez un type d’activité"}
                />
                <Spacer height={15} />
                <OpenSansText fontSize={16}>Exercice</OpenSansText>
                <Spacer height={15} />
                <CustomPicker
                    scrollable
                    withIcon
                    sport
                    disabled={fetchingSports || loading}
                    data={sports}
                    value={activity.sportId}
                    onPressItem={(itemId) => {
                        if (itemId < 0) {
                            setOpenSportModal(true)
                        }
                    }}
                    handleChange={(value) => {
                        setActivity((old) => ({ ...old, sportId: value }))
                    }}
                    //renderItem={renderItem}
                    title={"Sélectionnez une d’activité"}
                />

                <Spacer height={15} />

                <InputGroup
                    disabled={loading}
                    code
                    valid={isNumber(activity.duration)}
                    validation_message={"Minutes (ex: 20)"}
                    label={"Durée"}
                    placeholder={"Exemple : 45"}
                    value={activity.duration}
                    onChange={(txt) => setActivity((old) => ({ ...old, duration: txt }))}
                />

                <Spacer height={15} />

                {Platform.OS === "web" ? (
                    <View>
                        <OpenSansText fontWeight={"bold"} fontSize={16}>
                            Début de l'activité
                        </OpenSansText>
                        <input
                            disabled={loading}
                            style={{
                                height: 50,
                                borderRadius: 10,
                                paddingRight: 20,
                                paddingLeft: 10,
                                fontSize: 14,
                                marginTop: 10,
                                marginBottom: 20
                            }}
                            type="time"
                            value={time}
                            onChange={(e) => {
                                const timeValue = e.target.value
                                setTime(timeValue)
                                onChangeWebDateTime(timeValue)
                            }}
                        />
                    </View>
                ) : (
                    <InputGroup
                        disabled={loading}
                        valid={isValidTime(activity.start)}
                        validation_message={"Heure invalide 'ex : 16:00)"}
                        label={"Début de l'activité"}
                        placeholder={"Entrez une horaire exemple 16 : 00"}
                        value={activity.start}
                        onTouch={() => setDatePickerVisible(true)}
                        //onChange={(txt) => setActivity((old) => ({ ...old, start: txt }))}
                    />
                )}

                {datePickerVisible && (
                    <DateTimePicker
                        disabled={loading}
                        value={
                            isValidTime(activity.start)
                                ? moment(activity.start, "HH:mm").toDate()
                                : moment(new Date()).toDate()
                        }
                        mode={"time"}
                        is24Hour={true}
                        display="default"
                        onChange={onChangeDateTime}
                    />
                )}
                <Spacer height={15} />
                <OpenSansText fontSize={16}>Récurrence de l'activité</OpenSansText>
                <Spacer height={15} />
                <MultipleDaySelector
                    disabled={loading}
                    selected={activity.recurrenceDays}
                    handleChange={(value) => setActivity((old) => ({ ...old, recurrenceDays: value }))}
                />
                <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
                    <Button
                        onPress={() => {
                            navigation.goBack()
                        }}
                        text="Annuler"
                        disabled={loading}
                        width="48%"
                        backgroundColor={baseColors.green.light}
                        labelColor={baseColors.green.primary}
                    />
                    <Button
                        onPress={() => {
                            performSaveActivity()
                        }}
                        disabled={!canSubmit() || loading}
                        text="Enregistrer"
                        width="48%"
                        loading={loading}
                        backgroundColor={baseColors.green.primary}
                        labelColor={"white"}
                    />
                </View>
            </CustomScrollview>
        </ContainerStackScreen>
    )
}
